import { StandardEvents } from '@shopify/events';

const formatter = new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN' });

async function refreshCartPill() {
  try {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    const total = formatter.format(cart.total_price / 100);
    document.querySelectorAll('[data-bdh-cart-count]').forEach((el) => {
      el.textContent = String(cart.item_count);
    });
    document.querySelectorAll('[data-bdh-cart-total]').forEach((el) => {
      el.textContent = total;
    });
    document.querySelectorAll('[data-bdh-cart-pill]').forEach((el) => {
      el.setAttribute('aria-label', `Carrito: ${cart.item_count} productos, ${total}`);
    });
  } catch {
    // Si falla la lectura del carrito, se deja la píldora como la pintó Liquid.
  }
}

window.addEventListener('pageshow', refreshCartPill);
document.addEventListener('cart:update', refreshCartPill);
if (StandardEvents && StandardEvents.cartLinesUpdate) {
  document.addEventListener(StandardEvents.cartLinesUpdate, refreshCartPill);
}
